/** Minimal notification rule needed to decide fail-event coverage. */
export interface FailSubscriberRule {
  eventKey: string;
  sourceProcessDefinitionKey?: string | null;
  templateId?: string | null;
  isActive: boolean;
  recipients: ReadonlyArray<FailSubscriberRecipient>;
  escalation?: ReadonlyArray<{ recipients: ReadonlyArray<FailSubscriberRecipient> }>;
}

export interface FailSubscriberRecipient {
  emailAddress?: string | null;
  roleName?: string | null;
  entityId?: string | null;
}

const FAIL_EVENT = 'assignment.failed';

/** True when an active fail rule with a template and a real recipient covers this process. */
export function processHasFailSubscriber(processKey: string, rules: readonly FailSubscriberRule[]): boolean {
  const process = processKey.trim().toLowerCase();
  if (!process) {
    return false;
  }
  return rules.some(rule => ruleCoversProcess(rule, process));
}

function ruleCoversProcess(rule: FailSubscriberRule, process: string): boolean {
  if (!rule.isActive || rule.eventKey.trim().toLowerCase() !== FAIL_EVENT) {
    return false;
  }
  if (!rule.templateId?.trim()) {
    return false;
  }
  const source = rule.sourceProcessDefinitionKey?.trim().toLowerCase() ?? '';
  if (source && source !== process) {
    return false;
  }
  const people = [
    ...rule.recipients,
    ...(rule.escalation ?? []).flatMap(step => step.recipients),
  ];
  return people.some(recipient =>
    !!(recipient.emailAddress?.trim() || recipient.roleName?.trim() || recipient.entityId?.trim()));
}
